// PostgREST plafonne une requête .select() non paginée à 1000 lignes par défaut, sans erreur —
// au-delà, le reste est silencieusement tronqué. À utiliser pour toute table susceptible de
// dépasser ce seuil (croît avec l'usage, pas seulement avec la saisie manuelle).
/** Requête paginable : tout constructeur Supabase exposant .range(). */
interface RequetePaginable<T> {
  range(
    from: number,
    to: number,
  ): PromiseLike<{ data: T[] | null; error: { message: string } | null }>;
}

export async function fetchAllPaginated<T>(query: RequetePaginable<T>): Promise<T[]> {
  const PAGE = 1000;
  let rows: T[] = [];
  for (let from = 0; ; from += PAGE) {
    const { data, error } = await query.range(from, from + PAGE - 1);
    if (error) console.error('fetchAllPaginated:', error.message);
    if (error || !data) break;
    rows = rows.concat(data);
    if (data.length < PAGE) break;
  }
  return rows;
}
